import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seek-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  
  responsiveOptions;

  cities = [
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 1"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 2"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 3"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 4"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 5"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 6"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 7"
    }
  ];

  constructor() {
    this.responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }

  ngOnInit() {
  }

}
